<mat-card class="dialog-card link-business-profile">
  <mat-card-title class="dialog-card-header">
    <mat-toolbar class="dialog-toolbar" color="accent" fxLayout="row" fxLayoutAlign="space-between center">
      <h1 class="dialog-card-title">{{ 'I18N_ADMIN.DIALOG.LINK_BUSINESS_PROFILES_TO_USER.TITLE' | translate: param }}</h1>
      <button (click)="exit()" class="regular-round-button" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
  </mat-card-title>
  <mat-card-content class="dialog-card-content p-4" fxLayout="row" fxLayoutGap="20px">
    <section class="" fxFlex fxLayout="column">
      <mat-toolbar color="primary" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <p>{{ unselectedBusinessProfiles.length }} {{ 'I18N_ADMIN.DIALOG.LINK_BUSINESS_PROFILES_TO_USER.AVAILABLE_BUSINESS_PROFILES' | translate | uppercase }}</p>
        @if ((loader$ | async) && !isDeleteActionClicked) {
          <mat-progress-spinner [diameter]="20" color="accent" mode="indeterminate"></mat-progress-spinner>
        }
      </mat-toolbar>
      <mat-form-field class="filter-input" color="accent">
        <mat-label>{{ 'I18N_ADMIN.DIALOG.LINK_BUSINESS_PROFILES_TO_USER.FILTER_BUSINESS_PROFILES' | translate }}</mat-label>
        <mat-icon class="search-icon" matIconPrefix>search</mat-icon>
        <input (keyup)="filterBusinessProfiles($event, unselectedBusinessProfiles, false)" matInput type="text" />
      </mat-form-field>
      <mat-list class="height-300 two-line-list" fxFlex>
        @for (businessProfile of filteredUnselectedBusinessProfiles$ | async; track businessProfile.id) {
          <mat-list-item [lines]="2" class="hoverable">
            <mat-icon matListItemIcon>work_outline</mat-icon>
            <h3 matListItemTitle>{{ businessProfile?.name }}</h3>
            @if (canCreateBusinessProfile) {
              <button (click)="isDeleteActionClicked = false; addBusinessProfile(businessProfile)" class="regular-round-button" mat-icon-button matListItemMeta>
                <mat-icon>add</mat-icon>
              </button>
            }
            <p class="complementary-line" matListItemLine>
              <span> {{ 'I18N_ADMIN.DIALOG.LINK_BUSINESS_PROFILES_TO_USER.ENTITY' | translate }} : </span>
              <span>{{ businessProfile?.entityName }}</span>
            </p>
          </mat-list-item>
        }
      </mat-list>
    </section>
    <section class="" fxFlex fxLayout="column">
      <mat-toolbar color="primary" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <p>{{ currentBusinessProfiles.length }} {{ 'I18N_ADMIN.DIALOG.LINK_BUSINESS_PROFILES_TO_USER.SELECTED_BUSINESS_PROFILES' | translate | uppercase }}</p>
        @if ((loader$ | async) && isDeleteActionClicked) {
          <mat-progress-spinner [diameter]="20" color="accent" mode="indeterminate"></mat-progress-spinner>
        }
      </mat-toolbar>
      <mat-form-field class="filter-input" color="accent">
        <mat-label>{{ 'I18N_ADMIN.DIALOG.LINK_BUSINESS_PROFILES_TO_USER.FILTER_BUSINESS_PROFILES' | translate }}</mat-label>
        <mat-icon class="search-icon" matIconPrefix>search</mat-icon>
        <input (keyup)="filterBusinessProfiles($event, currentBusinessProfiles, true)" matInput type="text" />
      </mat-form-field>
      <mat-list class="height-300 two-line-list" fxFlex>
        @for (businessProfile of filteredCurrentBusinessProfiles$ | async; track businessProfile) {
          <mat-list-item [lines]="2" class="hoverable">
            <mat-icon matListItemIcon>work</mat-icon>
            <h3 matListItemTitle>{{ businessProfile?.name }}</h3>
            @if (canDeleteBusinessProfile) {
              <button
                (click)="isDeleteActionClicked = true; removeBusinessProfile(businessProfile)"
                class="regular-round-button"
                mat-icon-button
                matListItemMeta
              >
                <mat-icon>delete</mat-icon>
              </button>
            }
            <p class="complementary-line" matListItemLine>
              <span>{{ 'I18N_ADMIN.DIALOG.LINK_BUSINESS_PROFILES_TO_USER.ENTITY' | translate }} : </span>
              <span>{{ businessProfile?.entityName }}</span>
            </p>
          </mat-list-item>
        }
      </mat-list>
    </section>
  </mat-card-content>
  <mat-card-actions class="dialog-card-actions" fxLayout="row" fxLayoutAlign="end center">
    <button (click)="exit()" class="button-regular" color="accent" mat-raised-button>
      {{ 'I18N_ADMIN.DIALOG.LINK_BUSINESS_PROFILES_TO_USER.DONE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
